<template>
	<div class="az-pagination" :style="$vuetify.breakpoint.width < 720 ? heightPaginacaoStyle : ''">
		<v-pagination
			v-if="totalPaginas > 1"
			:value="page"
			:total-visible="totalVisible"
			:length="totalPaginas"
			class="paginacao-tabela"
			next-icon="mdi-chevron-right"
			prev-icon="mdi-chevron-left"
			@input="$emit('update:page', $event)"
		></v-pagination>
		<v-spacer v-if="totalPaginas <= 1"></v-spacer>
		<div class="az-select-pagination" :class="{ 'not-show-items-per-page': !showRowsPerPage }">
			<div v-if="totalItens > 0" class="pr-5 total-itens">
				{{ startAndStopPage }}
			</div>
			<div
				v-if="showRowsPerPage"
				id="rowsPerPage"
				class="align-center align-content-center d-flex justify-center"
			>
				<span>Linhas por página:</span>
				<v-select
					id="selectRowsPerPage"
					:value="rowsPerPage"
					:items="linhasPorPagina"
					dense
					@input="$emit('update:rowsPerPage', $event)"
					@change="$emit('resetar-page')"
				></v-select>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'paginacao-tabela',
	props: {
		rowsPerPage: {
			type: Number,
			required: true,
		},
		linhasPorPagina: {
			type: Array,
			default() {
				return [5, 10, 25, 50, 100]
			},
		},
		page: {
			type: Number,
			required: true,
		},
		totalVisible: {
			type: Number,
			default: 13,
		},
		totalItens: {
			type: Number,
			required: true,
		},
		totalPaginas: {
			type: Number,
			required: true,
		},
		showRowsPerPage: {
			type: Boolean,
			default: true,
		},
	},
	emits: ['resetar-page'],
	computed: {
		heightPaginacaoStyle() {
			return {
				height: `${this.totalPaginas > 1 ? '105px' : '50px'}`,
			}
		},
		startAndStopPage() {
			const totalItensPage = this.page * this.rowsPerPage
			const totalItensStart = (this.page - 1) * this.rowsPerPage + 1
			const totalItensStop = totalItensPage > this.totalItens ? this.totalItens : totalItensPage
			return `${totalItensStart} - ${totalItensStop} de ${this.totalItens}`
		},
	},
}
</script>

<style scoped lang="stylus">
.az-pagination
	align-items center

	.az-select-pagination
		width 60%
		justify-content flex-end

		.v-pagination__item
			width auto

		.v-input__append-inner
			align-self center

.not-show-items-per-page
	height (50/16)rem

@media (max-width: 720px)
	.az-pagination
		.az-select-pagination
			width 100%
			justify-content space-around
			flex-wrap wrap

		.paginacao-tabela
			display flex
			justify-content center

	.not-show-items-per-page
		height (40/16)rem
</style>
